// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
    IconDashboard,
    IconBuildingStore,
    IconBell,
    IconTicket,
    IconAccessPoint,
    IconPhoto,
    IconCalendar,
    IconSend,
    IconUsers,
    IconCreditCard,
    IconPencilQuestion,
    IconTrophy,
    IconAlignBoxLeftStretch,
    IconUserCog,
    IconBrandSuperhuman,
    IconInputSearch,
    IconFilePencil,
    IconDevices,
    IconMap2
} from '@tabler/icons-react';

const icons = {
    IconDashboard,
    IconBuildingStore,
    IconBell,
    IconTicket,
    IconAccessPoint,
    IconPhoto,
    IconCalendar,
    IconSend,
    IconUsers,
    IconCreditCard,
    IconPencilQuestion,
    IconTrophy,
    IconAlignBoxLeftStretch,
    IconUserCog,
    IconBrandSuperhuman,
    IconInputSearch,
    IconFilePencil,
    IconDevices,
    IconMap2
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const channel = {
    id: 'group',
    title: <FormattedMessage id="group" />,
    type: 'item',
    url: '/group',
    icon: icons.IconAlignBoxLeftStretch,
    breadcrumbs: false,
    soat: 1
};

const admin = {
    id: 'admin',
    title: <FormattedMessage id="admin" />,
    type: 'item',
    url: '/admin',
    icon: icons.IconUserCog,
    breadcrumbs: false,
    soat: 2
};

const dashboard = {
    id: 'dashboard',
    title: <FormattedMessage id="dashboard" />,
    type: 'item',
    url: '/dashboard',
    icon: icons.IconDashboard,
    breadcrumbs: false,
    soat: 3
};

const userList = {
    id: 'providerUser',
    title: <FormattedMessage id="providerUser" />,
    type: 'item',
    url: '/provideruser',
    icon: icons.IconUsers,
    breadcrumbs: false,
    soat: 4
};

const findoutUser = {
    id: 'findoutUser',
    title: <FormattedMessage id="findoutUser" />,
    type: 'item',
    url: '/findoutuser',
    icon: icons.IconUsers,
    breadcrumbs: false,
    soat: 5
};

const beacon = {
    id: 'beacon',
    title: <FormattedMessage id="beacon" />,
    type: 'item',
    url: '/beacon',
    icon: icons.IconAccessPoint,
    breadcrumbs: false,
    soat: 6
};

const task = {
    id: 'task',
    title: <FormattedMessage id="task" />,
    type: 'item',
    url: '/task',
    icon: icons.IconBell,
    breadcrumbs: false,
    soat: 7
};

const message = {
    id: 'message',
    title: <FormattedMessage id="message" />,
    type: 'item',
    url: '/message',
    icon: icons.IconSend,
    breadcrumbs: false,
    soat: 8
};

const product = {
    id: 'product',
    title: <FormattedMessage id="product" />,
    type: 'item',
    url: '/product',
    icon: icons.IconBrandSuperhuman,
    breadcrumbs: false,
    soat: 9
};

const survey = {
    id: 'survey',
    title: <FormattedMessage id="survey" />,
    type: 'item',
    url: '/survey',
    icon: icons.IconPencilQuestion,
    breadcrumbs: false,
    soat: 10
};

const prize = {
    id: 'prize',
    title: <FormattedMessage id="prize" />,
    type: 'item',
    url: '/prize',
    icon: icons.IconTrophy,
    breadcrumbs: false,
    soat: 11
};

const schedule = {
    id: 'schedule',
    title: <FormattedMessage id="schedule" />,
    type: 'item',
    url: '/schedule',
    icon: icons.IconCalendar,
    breadcrumbs: false,
    soat: 12
};

const keyword = {
    id: 'keyword',
    title: <FormattedMessage id="keyword" />,
    type: 'item',
    url: '/keyword',
    icon: icons.IconFilePencil,
    breadcrumbs: false,
    soat: 13
};
const subscription = {
    id: 'subscription',
    title: <FormattedMessage id="subscription" />,
    type: 'item',
    url: '/subscription',
    icon: icons.IconCreditCard,
    breadcrumbs: false,
    soat: 14
};

const shop = {
    id: 'shop',
    title: <FormattedMessage id="shop" />,
    type: 'item',
    url: '/shop',
    icon: icons.IconBuildingStore,
    breadcrumbs: false
};

const searchtype = {
    id: 'searchtype',
    title: <FormattedMessage id="searchtype" />,
    type: 'item',
    url: '/searchtype',
    icon: icons.IconInputSearch,
    breadcrumbs: false
};
const map = {
    id: 'map',
    title: <FormattedMessage id="map" />,
    type: 'collapse',
    icon: icons.IconMap2,
    children: [shop, searchtype],
    soat: 15
};

const sensor = {
    id: 'sensor',
    title: <FormattedMessage id="sensor" />,
    type: 'item',
    url: '/sensor',
    icon: icons.IconDevices,
    breadcrumbs: false,
    soat: 16
};

const mediamanager = {
    id: 'media-manager',
    title: <FormattedMessage id="media-manager" />,
    type: 'item',
    url: '/mediamanager',
    icon: icons.IconPhoto,
    breadcrumbs: false
};

const menuList = {
    id: 'Menu',
    title: <FormattedMessage id="Menu" />,
    icon: icons.IconDashboard,
    type: 'group',
    key: 'Menu',
    children: []
};

export default menuList;
